'use client';

import { NotFoundUI } from '../components/common/error/not-found';

export default function NotFound() {
  return <NotFoundUI />;
}
